import type { AppData } from "../../types";
import { el } from "../atoms/dom";
import { empty, initials, relativeDate } from "./dashboard_page";

export function customersPage(
  data: AppData,
  onOpenCustomer: (customerId: string) => void,
) {
  const root = el("div", { className: "customer-grid" });
  const input = el("input", { className: "search-input", attrs: { type: "search", placeholder: "İsim veya telefon numarası ara", "aria-label": "Müşteri ara" } });
  const render = () => {
    const query = input.value.toLocaleLowerCase("tr").trim();
    const customers = data.customers.filter((customer) => `${customer.displayName} ${customer.phoneNumber}`.toLocaleLowerCase("tr").includes(query));
    root.replaceChildren();
    if (!customers.length) {
      root.append(empty("Aramanızla eşleşen müşteri bulunamadı."));
      return;
    }
    for (const customer of customers) {
      const appointments = data.appointments.filter((item) => item.customerId === customer.id).sort((a, b) => b.startsAt.localeCompare(a.startsAt));
      const calls = data.conversations.filter((item) => item.customerId === customer.id).sort((a, b) => b.startedAt.localeCompare(a.startedAt));
      const card = el("article", {
        className: "customer-card customer-card--interactive",
        attrs: {
          role: "button",
          tabindex: "0",
          "aria-label": `${customer.displayName} profilini aç`,
        },
        onClick: () => onOpenCustomer(customer.id),
      }, el("header", {}, el("span", { className: "avatar", text: initials(customer.displayName) }), el("div", {}, el("h3", { text: customer.displayName }), el("a", { text: customer.phoneNumber, attrs: { href: `tel:${customer.phoneNumber}` } }))), el("div", { className: "customer-card__stats" }, el("span", {}, el("b", { text: String(appointments.length) }), "Randevu"), el("span", {}, el("b", { text: String(calls.length) }), "Görüşme")), el("p", { text: appointments[0] ? `Son randevu: ${relativeDate(appointments[0].startsAt)}` : "Henüz randevu yok" }));
      card.addEventListener("keydown", (event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onOpenCustomer(customer.id);
        }
      });
      card.querySelector("a")?.addEventListener("click", (event) => event.stopPropagation());
      root.append(card);
    }
  };
  input.addEventListener("input", render);
  render();
  return el("div", { className: "page-stack" }, el("div", { className: "search-bar" }, input), root);
}
